import { useState } from "react";
import { Button } from "../components/Button";
import { SparkIcon } from "../components/Icons";
import { useUiText } from "../i18n/useUiText";
import { useAppStore } from "../state/useAppStore";

const DISCARD_ANIMATION_MS = 380;

export function RevealScreen() {
  const t = useUiText();
  const [discarding, setDiscarding] = useState(false);
  const session = useAppStore((state) => state.session);
  const hand = useAppStore((state) => state.hand);
  const history = useAppStore((state) => state.history);
  const revealCardId = useAppStore((state) => state.revealCardId);
  const revealMode = useAppStore((state) => state.revealMode);
  const cancelReveal = useAppStore((state) => state.cancelReveal);
  const confirmReveal = useAppStore((state) => state.confirmReveal);

  const card =
    revealMode === "history"
      ? history.find((entry) => entry.card.cardId === revealCardId)?.card
      : hand.find((candidate) => candidate.cardId === revealCardId);

  if (session === null || card === undefined || revealMode === null) {
    return null;
  }

  const isHistory = revealMode === "history";
  const isDual = card.cardKind === "DUAL";

  // Discard is undoable and the button sits far from the thumb, so it acts
  // immediately (with a disappear animation) rather than asking to confirm.
  const discard = () => {
    setDiscarding(true);
    window.setTimeout(confirmReveal, DISCARD_ANIMATION_MS);
  };

  return (
    <main className="reveal-screen">
      <div className="reveal-screen__wash" aria-hidden="true" />
      <section
        aria-label={card.displayText}
        className={`reveal-card${isDual ? " reveal-card--dual" : ""}${
          discarding ? " reveal-card--discarding" : ""
        }`}
      >
        <div className="public-card" lang={session.theme.contentLocale}>
          {isDual ? (
            <span className="public-card__kind">
              <SparkIcon />
              {t("card.dual")}
            </span>
          ) : null}
          <strong>{card.displayText}</strong>
        </div>

        <div className="reveal-card__actions">
          {isHistory ? (
            <Button onClick={confirmReveal}>{t("reveal.historyDone")}</Button>
          ) : (
            <>
              <Button onClick={discard} variant="danger">
                {t("reveal.discard")}
              </Button>
              <Button onClick={cancelReveal} variant="secondary">
                {t("reveal.putBack")}
              </Button>
            </>
          )}
        </div>
      </section>
    </main>
  );
}
